module.exports = {
  STARTED: 'started',
  PAUSED: 'paused',
  STOPPED: 'stopped',
  NONE: 'none'
}
